export default __webpack_public_path__ + "static/media/bmw3.5727c0d9.png";